var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.729,
    height: 10.481,
    viewBox: "0 0 12.729 10.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "message",
    d: "M10.119.5H2.61A2.613,2.613,0,0,0,0,3.11V7.142A2.568,2.568,0,0,0,1.847,9.611l1.261,1.261a.373.373,0,0,0,.527,0L4.792,9.716h5.327a2.613,2.613,0,0,0,2.61-2.61V3.11A2.613,2.613,0,0,0,10.119.5ZM3.624,5.767A.373.373,0,0,1,4,5.394H8.732a.373.373,0,0,1,0,.746H4A.373.373,0,0,1,3.624,5.767Zm5.109-.945H4a.373.373,0,1,1,0-.746H8.732a.373.373,0,0,1,0,.746Zm0,0",
    transform: "translate(0 -0.5)",
    fill: "#172b37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b4e64e958bb72b80b077a4b2a910d7aa.svg";
export { ForwardRef as ReactComponent };